import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    getByProp(prop) {
        return interfaceAjax({
            url: '/admin/sysProperties/getByProp',
            method: 'post',
            data: {prop:prop}
        });
    },
    sysName() {
        return interfaceAjax({
            url: '/admin/sysProperties/sysName',
            method: 'post',
        });
    },
}
